import { epochToViewUTC } from '@tokeet-frontend/tv3-platform'
import { getExtraMethod, getExtraStatus } from './constants'
import * as lodash from 'lodash'

export interface ExtraResponse {
  pkey: string
  account: number
  payment_account: string

  rental_id: string
  inquiry_id: string

  attachments: string[]

  description: string
  category: string
  date: number
  method: string
  status: number
  amount: number

  created: number
  archived: number
  created_by: string
}

export interface ExtraView extends ExtraResponse {
  createdView: string
  dateView: string
  methodView: string
  statusView: string

  createdByView: string

  rentalView: string
  amountCodeView: string
}

export interface SearchExtraParams {
  rentals: string[]
  method: string
  status: number | string
  categories: string[]
  period: {
    from: number
    to: number
  }
}

export interface CreateExtraPayload {
  date: number
  category: string
  amount: number
  status: number
  method: string

  inquiry_id?: string
  rental_id?: string
  description: string
  attachments?: string[]
}

export type UpdateExtraPayload = Partial<CreateExtraPayload>

export function toExtraView(extra: ExtraResponse): ExtraView {
  extra.date = +extra.date
  return {
    ...extra,
    status: +extra.status,
    createdView: epochToViewUTC(extra.created),
    dateView: epochToViewUTC(extra.date),
    methodView: lodash.capitalize(getExtraMethod(extra.method)),
    statusView: getExtraStatus(extra.status),
  } as ExtraView
}
